import PropTypes from 'prop-types';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';
import styles from './Status.module.scss';

/**
 * Status component following GDS Design System tag pattern
 * https://design-system.service.gov.uk/components/tag/
 *
 * Supports all GOV.UK tag color variants & custom colour variants from Iona's designs
 */
const Status = ({ children, variant, className, ...props }) => {
    const classNames = [
        'govuk-tag',
        styles.status,
        styles[variant],
        className
    ].filter(Boolean).join(' ');

    return (
        <strong className={classNames} {...props}>
            {children}
        </strong>
    );
};

Status.propTypes = {
    ...defaultAriaProps,
    children: PropTypes.node.isRequired,
    variant: PropTypes.oneOf([
        'grey', // Default
        'green', // Success/active
        'teal', // Information
        'blue', // Information
        'purple', // Information
        'magenta', // Information
        'red', // Error/important
        'orange', // Warning
        'yellow' // Warning
    ]),
    className: PropTypes.string
};

Status.defaultProps = {
    variant: 'grey',
    className: ''
};

export default Status;
